import { fetchIsNeedUpgradeBrowser } from '@/apis/commonApi';
import { ref } from 'vue';
export const useUpgradeBrowserData = () => {
  const isShow = ref(false);
  const downloadUrl = ref('');
  const ua = navigator.userAgent.toLowerCase();
  const BrowserKey = `browser_info`;
  const BrowserValue = `${navigator.appName}_${parseFloat(navigator.appVersion)}`;
  const getUpgradeBrowserDownloadUrl = async () => {
    const { data, status } = await fetchIsNeedUpgradeBrowser();
    if (status === 1) {
      if (ua.indexOf('windows', 0) != -1) {
        return data.widows;
      } else if (ua.indexOf('mac', 0) != -1) {
        return data.macos;
      } else {
        return data.other || 'https://www.google.cn/chrome/';
      }
    } else {
      return '';
    }
  };
  // 检测是否显示浏览器提示：不是移动端 且 非chrome浏览器 且 没有关闭过 且 能拿到需要下载的浏览器下载地址 则显示
  const check = async () => {
    if (!ua.match(/chrome\/([\d.]+)/)) {
      const browserInfo = localStorage.getItem(BrowserKey);
      if (browserInfo === null || browserInfo === '') {
        //用户未选择过不下载
        downloadUrl.value = await getUpgradeBrowserDownloadUrl();
        if (downloadUrl.value !== '') {
          isShow.value = true;
          return;
        }
      }
    }
    isShow.value = false;
  };

  const close = () => {
    localStorage.setItem(BrowserKey, BrowserValue);
    isShow.value = false;
  };

  return {
    close,
    check,
    isShow,
    downloadUrl,
  };
};
